export default {
  'pages.account.title': 'Account Information',
  'pages.account.phone': 'Phone',
  'pages.account.email': 'Email',
  'pages.account.companyName': 'Company Name',
  'pages.account.signOut': 'Sign out',
  'pages.account.signOut.success': 'Sign out success',
  'pages.account.signOut.fail': 'Sign out fail, try again',
};
